import React, { FC, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { initDataStore } from 'src/store/taxData';
import { insurfeeDataStore } from 'src/store/insurfee';
import { defaultData } from 'src/static/sample/natinalPensionData';
import TaxTopButton from 'src/components/organisms/template/StepC/template/TaxModal/TaxTopButton';
import TaxBottomDesc from 'src/components/organisms/template/StepC/template/TaxModal/TaxBottomDesc';

import { fetchDeleteInsurfeeData, insurfeeInfoDataFn } from 'src/fetch/stepC/insurfee';
import { familyDataStore } from 'src/store/familyInfo';
import { getMemberInfo } from 'src/utils/common';

import GridList from './list';
import AddGrid from './upsert';
import '../tableRef.scss';
import './style.scss';

interface Props {
  type: string;
}
const Grid: FC<Props> = ({ type }) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  // 보험금내역
  const insurfeeDataState = insurfeeDataStore((state: any) => state.bind);
  const bindStoreParam = insurfeeDataStore((state: any) => state.param);
  const bindStoreBindParam = insurfeeDataStore((state: any) => state.bindParam);
  const data = insurfeeDataStore((state: any) => state.result).data || [];
  const familyInfoDataState = familyDataStore((state: any) => state.bind);

  const userInfoData: any = getMemberInfo();

  const checkTypeEvt = () => {};
  const familyInitResult = initDataStore((state: any) => state.result);
  const familyInitBind = initDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {};

  // const viewData: any = defaultData.init.data || [];

  let viewData: any = [];
  const dataSet = data;
  // const dataSet = data.filter((item: any) => item.infoData !== undefined);
  viewData = dataSet;

  //:State
  const [viewTypeState, setViewTypeState] = useState({ type: '' });
  const viewName = '보험료';

  // 보험료
  useEffect(() => {
    const param = userInfoData;
    insurfeeInfoDataFn(errorModalState, param, insurfeeDataState, queryClient, familyInfoDataState);
  }, [bindStoreParam]);

  const addClickEvent = () => {
    const payload = {
      active: '_active',
      title: viewName + ' 내역 추가',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <AddGrid data={viewData} type="insert" />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };
  const modifyClickEvent = () => {
    viewTypeState.type === ''
      ? setViewTypeState({ type: 'modify' })
      : setViewTypeState({ type: '' });
  };

  const modifyItemEvent = (item: any) => {
    const payload = {
      active: '_active',
      title: viewName + ' 내역 수정',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <AddGrid data={item} type="update" />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };
  const deleteItemEvent = (selItem: any) => {
    const confirmDiv = () => {
      return (
        <div className="_confirm_modal_content">
          <div className="_title">해당 내용을 삭제합니다.</div>
          <div className="_desc">내용을 삭제 하시겠습니까?</div>
        </div>
      );
    };
    setConfirmModalState({
      active: '_active',
      content: confirmDiv(),
      cancleEvt: (item: any) => {
        closeModalState({ content: null, active: '' });
      },
      confirmEvt: (item: any) => {
        // Fetch Data
        const param = {
          acct_year: selItem.infoData?.acct_year,
          co_cd: selItem.infoData?.co_cd,
          co_id: selItem.infoData?.co_id,
          family_seqid: selItem.infoData?.family_seqid,
          in_data_seqid: selItem.infoData?.in_data_seqid,
        };
        // return false;
        fetchDeleteInsurfeeData(param, queryClient, errorModalState, loadingState, () => {
          const initialSeq = bindStoreParam.initialSeq || 0;
          bindStoreBindParam({ initialSeq: initialSeq + 1 });
          setContentModalState({
            active: '',
          });
        });

        //Close
        closeModalState({ content: null, active: '' });
      },
    });
  };

  const listGrid = () => {
    return (
      <div className="_list_grid">
        <TaxTopButton
          addClickEvt={addClickEvent}
          modifyClickEvt={modifyClickEvent}
          viewType={viewTypeState.type}
        />
        <GridList
          data={viewData}
          viewType={viewTypeState.type}
          modifyItemEvt={modifyItemEvent}
          deleteItemEvt={deleteItemEvent}
        />
        <TaxBottomDesc />
      </div>
    );
  };

  return <div className="_creditcard_layout">{listGrid()}</div>;
};

export default Grid;
